export default __webpack_public_path__ + "static/media/player1.ff98a2b3.png";